import * as Styles from './Heading.styles';

const Heading = ({ children, classNames = '', variant = '', title = '' }) => {
  if (variant === 'secondary') {
    return (
      <div className="flex justify-between flex-wrap md:flex-nowrap">
        <div className="w-full md:w-2/5">
          <Styles.Heading component="h1" className={classNames}>
            {title}
          </Styles.Heading>
        </div>
        <div className="w-full md:w-3/5 flex justify-end mt-3 md:mt-0 relative">
          {children}
        </div>
      </div>
    );
  }

  return (
    <Styles.Heading component="h1" className={classNames}>
      {children}
    </Styles.Heading>
  );
};

export default Heading;
